
import React from 'react';
import ServiceRequestToast from './ServiceRequestToast';

const ServiceRequestStatusUpdates = ({ serviceRequest, handleStatusChange }) => {
    return (
        <ServiceRequestToast serviceRequest={serviceRequest} handleStatusChange={handleStatusChange} />
    )
}

export default ServiceRequestStatusUpdates;